import { useEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

export default function ScrollToTop() {
  const location = useLocation();
  const { pathname } = location;
  const navType = useNavigationType();
  const previousPathname = useRef(null);

  useEffect(() => {
    const samePage = previousPathname.current === pathname;
    previousPathname.current = pathname;
    // A second click on the current section link replaces the entry (PUSH → REPLACE)
    // without changing the URL. The page is already on that section, so jumping to
    // the top here would leave the reader away from what they asked for.
    if (samePage && location.hash) {
      return;
    }

    if (location.state?.overlayBackgroundLocation || location.state?.preserveScroll) {
      return;
    }

    // Only scroll to top if this is a new navigation (PUSH/REPLACE)
    // POP happens on browser Back/Forward, where we want to preserve native scroll restoration
    if (navType !== 'POP') {
      window.scrollTo(0, 0);
    }
  }, [location.state, pathname, navType]);

  return null;
}
